<template>
    <CContainer class="p-0">
        <CRow class="mb-4">
            <CCol md="12" sm="12">
                <h5>
                    {{ $t("field_mapping") }}
                </h5>
                <p class="mb-0">
                    {{
                        $t(
                            "You can assign data from Zoho with data from the platform itself."
                        )
                    }}.
                </p>
                <CustomTable
                    :items="settings.fieldsMapping.items"
                    :fields="settings.fieldsMapping.fields"
                    :resizable="false"
                >
                    <template #no-items-view>
                        <div class="block-no-items section">
                            <h2 class="section__title text-no-items">
                                {{ $t("Add the fields to mapping") }}
                            </h2>
                            <CButton
                                color="success"
                                class="button m-2 shadow"
                                @click="addItemToTable('fieldsMapping')"
                            >
                                <span class="button__icon">
                                    <CIcon :content="$options.icons.cilPlus" />
                                </span>
                                <span class="button__text">
                                    {{ $t("Add field") }}
                                </span>
                            </CButton>
                        </div>
                    </template>
                    <template #under-table>
                        <CButton
                            color="success"
                            class="button m-2 shadow"
                            @click="addItemToTable('fieldsMapping')"
                            v-if="settings.fieldsMapping.items.length > 0"
                        >
                            <span class="button__icon">
                                <CIcon :content="$options.icons.cilPlus" />
                            </span>
                            <span class="button__text">
                                {{ $t("Add field") }}
                            </span>
                        </CButton>
                    </template>
                    <template #value="{ index }">
                        <SelectAsync
                            :value.sync="
                                settings.fieldsMapping.items[index].value
                            "
                            :options="fieldsFromApiZoho"
                            :placeholder="$t('Select an option')"
                            :invalidFeedback="$t('Option is requiered')"
                            size="sm"
                            class="mb-0"
                        />
                    </template>
                    <template #name="{ index }">
                        <SelectAsync
                            :value.sync="
                                settings.fieldsMapping.items[index].name
                            "
                            @change="changeFieldMapping(index, 'fieldsMapping')"
                            :options="fieldsLG"
                            :placeholder="$t('Select a field')"
                            :invalidFeedback="$t('Field is requiered')"
                            size="sm"
                            class="mb-0"
                        />
                    </template>
                    <template #details="{ item, index }">
                        <CCollapse :show="Boolean(item._toggled)">
                            <CCardBody>
                                <CRow>
                                    <CCol md="12" sm="12">
                                        <h5>
                                            {{ $t("Adapter Values") }}
                                        </h5>
                                        <p class="mb-1">
                                            {{
                                                $t(
                                                    "We will update the values coming from Facebook with the values you have set in this configuration."
                                                )
                                            }}
                                        </p>
                                        <CDataTable
                                            class="overflow-visible"
                                            :items="
                                                settings.fieldsMapping.items[
                                                    index
                                                ]['fieldAdapter']
                                            "
                                            :fields="[
                                                {
                                                    key: 'name',
                                                    label: 'Zoho value',
                                                },
                                                {
                                                    key: 'value',
                                                    label: 'Leadgrease value',
                                                },
                                                {
                                                    key: 'options',
                                                    label: 'options',
                                                },
                                            ]"
                                            hover
                                            border
                                            striped
                                        >
                                            <template #no-items-view>
                                                <div
                                                    class="block-no-items section"
                                                >
                                                    <h2
                                                        class="section__title text-no-items"
                                                    >
                                                        {{
                                                            $t(
                                                                "Add a fixed field"
                                                            )
                                                        }}
                                                    </h2>
                                                    <CButton
                                                        color="success"
                                                        class="button m-2 shadow"
                                                        :title="$t('Add field')"
                                                        @click="
                                                            addItemToFieldAdapterTable(
                                                                index,
                                                                'fieldsMapping'
                                                            )
                                                        "
                                                    >
                                                        <span
                                                            class="button__icon"
                                                        >
                                                            <CIcon
                                                                :content="
                                                                    $options
                                                                        .icons
                                                                        .cilPlus
                                                                "
                                                            />
                                                        </span>
                                                        <span
                                                            class="button__text"
                                                        >
                                                            {{
                                                                $t("Add field")
                                                            }}
                                                        </span>
                                                    </CButton>
                                                </div>
                                            </template>
                                            <template #under-table>
                                                <CButton
                                                    color="success"
                                                    class="button m-2 shadow"
                                                    @click="
                                                        addItemToFieldAdapterTable(
                                                            index,
                                                            'fieldsMapping'
                                                        )
                                                    "
                                                    v-if="
                                                        settings.fieldsMapping
                                                            .items[index][
                                                            'fieldAdapter'
                                                        ] &&
                                                        settings.fieldsMapping
                                                            .items[index][
                                                            'fieldAdapter'
                                                        ].length > 0
                                                    "
                                                >
                                                    <span class="button__icon">
                                                        <CIcon
                                                            :content="
                                                                $options.icons
                                                                    .cilPlus
                                                            "
                                                        />
                                                    </span>
                                                    <span class="button__text">
                                                        {{ $t("Add field") }}
                                                    </span>
                                                </CButton>
                                            </template>
                                            <template #name="{ item }">
                                                <td>
                                                    <SelectAsync
                                                        v-if="
                                                            listValuesAdapterZoho[
                                                                settings
                                                                    .fieldsMapping
                                                                    .items[
                                                                    index
                                                                ].value
                                                            ] &&
                                                            listValuesAdapterZoho[
                                                                settings
                                                                    .fieldsMapping
                                                                    .items[
                                                                    index
                                                                ].value
                                                            ].length > 0
                                                        "
                                                        :value.sync="item.name"
                                                        :options="
                                                            listValuesAdapterZoho[
                                                                settings
                                                                    .fieldsMapping
                                                                    .items[
                                                                    index
                                                                ].value
                                                            ]
                                                        "
                                                        :placeholder="
                                                            $t(
                                                                'enter_file_name'
                                                            )
                                                        "
                                                        :invalidFeedback="
                                                            $t(
                                                                'Field is requiered'
                                                            )
                                                        "
                                                        size="sm"
                                                    />
                                                    <CInput
                                                        v-else
                                                        :placeholder="
                                                            $t(
                                                                'enter_file_name'
                                                            )
                                                        "
                                                        size="sm"
                                                        :value.sync="item.name"
                                                    />
                                                </td>
                                            </template>
                                            <template #value="{ item }">
                                                <td>
                                                    <SelectAsync
                                                        v-if="
                                                            listValuesAdapterLG[
                                                                settings
                                                                    .fieldsMapping
                                                                    .items[
                                                                    index
                                                                ].name
                                                            ] &&
                                                            listValuesAdapterLG[
                                                                settings
                                                                    .fieldsMapping
                                                                    .items[
                                                                    index
                                                                ].name
                                                            ].length > 0
                                                        "
                                                        :value.sync="item.value"
                                                        :options="
                                                            listValuesAdapterLG[
                                                                settings
                                                                    .fieldsMapping
                                                                    .items[
                                                                    index
                                                                ].name
                                                            ]
                                                        "
                                                        :placeholder="
                                                            $t(
                                                                'enter_file_value'
                                                            )
                                                        "
                                                        :invalidFeedback="
                                                            $t(
                                                                'Field is requiered'
                                                            )
                                                        "
                                                        size="sm"
                                                    />
                                                    <CInput
                                                        v-else
                                                        :placeholder="
                                                            $t(
                                                                'enter_file_value'
                                                            )
                                                        "
                                                        size="sm"
                                                        :value.sync="item.value"
                                                    />
                                                </td>
                                            </template>
                                            <template #options="{ item }">
                                                <td class="py-2 text-center">
                                                    <CButton
                                                        color="danger"
                                                        variant="outline"
                                                        square
                                                        size="sm"
                                                        @click="
                                                            deleteItemToFieldAdapterTable(
                                                                index,
                                                                item.name,
                                                                'fieldsMapping'
                                                            )
                                                        "
                                                    >
                                                        <CIcon
                                                            :content="
                                                                $options.icons
                                                                    .cilTrash
                                                            "
                                                        />
                                                    </CButton>
                                                </td>
                                            </template>
                                        </CDataTable>
                                    </CCol>
                                </CRow>
                            </CCardBody>
                        </CCollapse>
                    </template>
                    <template #options="{ index }">
                        <div class="table-options">
                            <CButton
                                color="success"
                                variant="outline"
                                square
                                size="sm"
                                @click="toggleDetails('fieldsMapping', index)"
                                class="mr-2"
                            >
                                <CIcon :content="$options.icons.cilPencil" />
                            </CButton>
                            <CButton
                                color="danger"
                                variant="outline"
                                square
                                size="sm"
                                @click="
                                    deleteItemToTable('fieldsMapping', index)
                                "
                            >
                                <CIcon :content="$options.icons.cilTrash" />
                            </CButton>
                        </div>
                    </template>
                </CustomTable>
            </CCol>
        </CRow>
        <CRow class="mb-4" v-if="moduleApiName == 'Sales_Orders'">
            <CCol md="12" sm="12">
                <h5>
                    {{ $t("Field mapping products") }}
                </h5>
                <CustomTable
                    :items="settings.fieldsMappingProduct.items"
                    :fields="settings.fieldsMappingProduct.fields"
                    :resizable="false"
                >
                    <template #no-items-view>
                        <div class="block-no-items section">
                            <h2 class="section__title text-no-items">
                                {{ $t("Add the fields to mapping") }}
                            </h2>
                            <CButton
                                color="success"
                                class="button m-2 shadow"
                                @click="addItemToTable('fieldsMappingProduct')"
                            >
                                <span class="button__icon">
                                    <CIcon :content="$options.icons.cilPlus" />
                                </span>
                                <span class="button__text">
                                    {{ $t("Add field") }}
                                </span>
                            </CButton>
                        </div>
                    </template>
                    <template #under-table>
                        <CButton
                            color="success"
                            class="button m-2 shadow"
                            @click="addItemToTable('fieldsMappingProduct')"
                            v-if="
                                settings.fieldsMappingProduct.items.length > 0
                            "
                        >
                            <span class="button__icon">
                                <CIcon :content="$options.icons.cilPlus" />
                            </span>
                            <span class="button__text">
                                {{ $t("Add field") }}
                            </span>
                        </CButton>
                    </template>
                    <template #value="{ index }">
                        <SelectAsync
                            :value.sync="
                                settings.fieldsMappingProduct.items[index].value
                            "
                            :options="fieldsProductFromApiZoho"
                            :placeholder="$t('Select an option')"
                            :invalidFeedback="$t('Option is requiered')"
                            size="sm"
                            class="mb-0"
                        />
                    </template>
                    <template #name="{ index }">
                        <SelectAsync
                            :value.sync="
                                settings.fieldsMappingProduct.items[index].name
                            "
                            @change="
                                changeFieldMapping(
                                    index,
                                    'fieldsMappingProduct'
                                )
                            "
                            :options="fieldsProductLG"
                            :placeholder="$t('Select a field')"
                            :invalidFeedback="$t('Field is requiered')"
                            size="sm"
                            class="mb-0"
                        />
                    </template>
                    <template #details="{ item, index }">
                        <CCollapse :show="Boolean(item._toggled)">
                            <CCardBody>
                                <CRow>
                                    <CCol md="12" sm="12">
                                        <h5>
                                            {{ $t("Adapter Values") }}
                                        </h5>
                                        <p class="mb-1">
                                            {{
                                                $t(
                                                    "We will update the values coming from Facebook with the values you have set in this configuration."
                                                )
                                            }}
                                        </p>
                                        <CDataTable
                                            class="overflow-visible"
                                            :items="
                                                settings.fieldsMappingProduct
                                                    .items[index][
                                                    'fieldAdapter'
                                                ]
                                            "
                                            :fields="[
                                                {
                                                    key: 'name',
                                                    label: 'Zoho value',
                                                },
                                                {
                                                    key: 'value',
                                                    label: 'Leadgrease value',
                                                },
                                                {
                                                    key: 'options',
                                                    label: 'options',
                                                },
                                            ]"
                                            hover
                                            border
                                            striped
                                        >
                                            <template #no-items-view>
                                                <div
                                                    class="block-no-items section"
                                                >
                                                    <h2
                                                        class="section__title text-no-items"
                                                    >
                                                        {{
                                                            $t(
                                                                "Add a fixed field"
                                                            )
                                                        }}
                                                    </h2>
                                                    <CButton
                                                        color="success"
                                                        class="button m-2 shadow"
                                                        :title="$t('Add field')"
                                                        @click="
                                                            addItemToFieldAdapterTable(
                                                                index,
                                                                'fieldsMappingProduct'
                                                            )
                                                        "
                                                    >
                                                        <span
                                                            class="button__icon"
                                                        >
                                                            <CIcon
                                                                :content="
                                                                    $options
                                                                        .icons
                                                                        .cilPlus
                                                                "
                                                            />
                                                        </span>
                                                        <span
                                                            class="button__text"
                                                        >
                                                            {{
                                                                $t("Add field")
                                                            }}
                                                        </span>
                                                    </CButton>
                                                </div>
                                            </template>
                                            <template #under-table>
                                                <CButton
                                                    color="success"
                                                    class="button m-2 shadow"
                                                    @click="
                                                        addItemToFieldAdapterTable(
                                                            index,
                                                            'fieldsMappingProduct'
                                                        )
                                                    "
                                                    v-if="
                                                        settings
                                                            .fieldsMappingProduct
                                                            .items[index][
                                                            'fieldAdapter'
                                                        ] &&
                                                        settings
                                                            .fieldsMappingProduct
                                                            .items[index][
                                                            'fieldAdapter'
                                                        ].length > 0
                                                    "
                                                >
                                                    <span class="button__icon">
                                                        <CIcon
                                                            :content="
                                                                $options.icons
                                                                    .cilPlus
                                                            "
                                                        />
                                                    </span>
                                                    <span class="button__text">
                                                        {{ $t("Add field") }}
                                                    </span>
                                                </CButton>
                                            </template>
                                            <template #name="{ item }">
                                                <td>
                                                    <SelectAsync
                                                        v-if="
                                                            listValuesProductAdapterZoho[
                                                                settings
                                                                    .fieldsMappingProduct
                                                                    .items[
                                                                    index
                                                                ].value
                                                            ] &&
                                                            listValuesProductAdapterZoho[
                                                                settings
                                                                    .fieldsMappingProduct
                                                                    .items[
                                                                    index
                                                                ].value
                                                            ].length > 0
                                                        "
                                                        :value.sync="item.name"
                                                        :options="
                                                            listValuesProductAdapterZoho[
                                                                settings
                                                                    .fieldsMappingProduct
                                                                    .items[
                                                                    index
                                                                ].value
                                                            ]
                                                        "
                                                        :placeholder="
                                                            $t(
                                                                'enter_file_name'
                                                            )
                                                        "
                                                        :invalidFeedback="
                                                            $t(
                                                                'Field is requiered'
                                                            )
                                                        "
                                                        size="sm"
                                                    />
                                                    <CInput
                                                        v-else
                                                        :placeholder="
                                                            $t(
                                                                'enter_file_name'
                                                            )
                                                        "
                                                        size="sm"
                                                        :value.sync="item.name"
                                                    />
                                                </td>
                                            </template>
                                            <template #value="{ item }">
                                                <td>
                                                    <SelectAsync
                                                        v-if="
                                                            listValuesProductAdapterLG[
                                                                settings
                                                                    .fieldsMappingProduct
                                                                    .items[
                                                                    index
                                                                ].name
                                                            ] &&
                                                            listValuesProductAdapterLG[
                                                                settings
                                                                    .fieldsMappingProduct
                                                                    .items[
                                                                    index
                                                                ].name
                                                            ].length > 0
                                                        "
                                                        :value.sync="item.value"
                                                        :options="
                                                            listValuesProductAdapterLG[
                                                                settings
                                                                    .fieldsMappingProduct
                                                                    .items[
                                                                    index
                                                                ].name
                                                            ]
                                                        "
                                                        :placeholder="
                                                            $t(
                                                                'enter_file_value'
                                                            )
                                                        "
                                                        :invalidFeedback="
                                                            $t(
                                                                'Field is requiered'
                                                            )
                                                        "
                                                        size="sm"
                                                    />
                                                    <CInput
                                                        v-else
                                                        :placeholder="
                                                            $t(
                                                                'enter_file_value'
                                                            )
                                                        "
                                                        size="sm"
                                                        :value.sync="item.value"
                                                    />
                                                </td>
                                            </template>
                                            <template #options="{ item }">
                                                <td class="py-2 text-center">
                                                    <CButton
                                                        color="danger"
                                                        variant="outline"
                                                        square
                                                        size="sm"
                                                        @click="
                                                            deleteItemToFieldAdapterTable(
                                                                index,
                                                                item.name,
                                                                'fieldsMappingProduct'
                                                            )
                                                        "
                                                    >
                                                        <CIcon
                                                            :content="
                                                                $options.icons
                                                                    .cilTrash
                                                            "
                                                        />
                                                    </CButton>
                                                </td>
                                            </template>
                                        </CDataTable>
                                    </CCol>
                                </CRow>
                            </CCardBody>
                        </CCollapse>
                    </template>
                    <template #options="{ index }">
                        <div class="table-options">
                            <CButton
                                color="success"
                                variant="outline"
                                square
                                size="sm"
                                @click="
                                    toggleDetails('fieldsMappingProduct', index)
                                "
                                class="mr-2"
                            >
                                <CIcon :content="$options.icons.cilPencil" />
                            </CButton>
                            <CButton
                                color="danger"
                                variant="outline"
                                square
                                size="sm"
                                @click="
                                    deleteItemToTable(
                                        'fieldsMappingProduct',
                                        index
                                    )
                                "
                            >
                                <CIcon :content="$options.icons.cilTrash" />
                            </CButton>
                        </div>
                    </template>
                </CustomTable>
            </CCol>
        </CRow>
        <CRow class="mb-4">
            <CCol md="12" sm="12">
                <h5>
                    {{ $t("Fixed fields") }}
                </h5>
                <p class="mb-0">
                    {{
                        $t(
                            "You can create fixed fields that you want to link and do not come from the form"
                        )
                    }}.
                </p>
                <TableFixedFields :value.sync="settings.fixedFields" />
            </CCol>
        </CRow>
    </CContainer>
</template>

<script>
import baseMixin from "~/mixins/base.js";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";

import SelectAsync from "£lement/SelectAsync";
import ButtonSave from "~/components/ButtonSave.vue";
import TableFixedFields from "~/components/TableFixedFields.vue";
import TableDynamicFields from "~/components/TableDynamicFields.vue";
import CustomTable from "~/components/CustomTable";
import { cilPlus, cilTrash, cilPencil } from "@coreui/icons";
import {
    ZOHO_ACTIONS_WEBHOOKS,
    ZOHO_ACTION_GET_FIELDS,
    ZOHO_ACTION_GET_FIELDS_LG,
} from "~/pages/app/inputs/Integrations/Config/Types";
export default {
    name: "ZohoSettings",
    mixins: [baseMixin, validationMixin],
    icons: {
        cilPlus,
        cilTrash,
        cilPencil,
    },
    consts: {
        ZOHO_ACTIONS_WEBHOOKS,
        ZOHO_ACTION_GET_FIELDS,
        ZOHO_ACTION_GET_FIELDS_LG,
    },
    components: {
        SelectAsync,
        ButtonSave,
        TableFixedFields,
        TableDynamicFields,
        CustomTable,
        SelectAsync,
    },
    data() {
        return {
            settings: {
                fieldsMapping: {
                    fields: [
                        {
                            key: "value",
                            label: "Zoho field",
                        },
                        {
                            key: "name",
                            label: "Leadgrease field",
                        },
                        {
                            key: "fieldAdapter",
                            label: "Adapter Values",
                            _active: false,
                        },
                        {
                            key: "type",
                            label: "Type",
                            _active: false,
                        },
                        {
                            key: "options",
                            label: "Options",
                        },
                    ],
                    items: [],
                },
                fieldsMappingProduct: {
                    fields: [
                        {
                            key: "value",
                            label: "Zoho field",
                        },
                        {
                            key: "name",
                            label: "Leadgrease field",
                        },
                        {
                            key: "fieldAdapter",
                            label: "Adapter Values",
                            _active: false,
                        },
                        {
                            key: "type",
                            label: "Type",
                            _active: false,
                        },
                        {
                            key: "options",
                            label: "Options",
                        },
                    ],
                    items: [],
                },
            },
            fieldsFromApiZoho: [],
            fieldsProductFromApiZoho: [],
            fieldsLG: [],
            fieldsProductLG: [],
            listValuesAdapterLG: [],
            listValuesProductAdapterLG: [],
            listValuesAdapterZoho: [],
            listValuesProductAdapterZoho: [],
            moduleApiName: null,
        };
    },
    validations: {
        settings: {},
    },
    props: {
        plugin_marketing_credentials_uuid: {
            required: true,
        },
        action_uuid: {
            required: true,
        },
        value: {
            default: () => ({
                fieldsMapping: {
                    fields: [
                        {
                            key: "value",
                            label: "Value",
                        },
                        {
                            key: "name",
                            label: "Name",
                        },
                        {
                            key: "type",
                            label: "Type",
                            _active: false,
                        },
                        {
                            key: "fieldAdapter",
                            label: "Adapter Values",
                            _active: false,
                        },
                        {
                            key: "options",
                            label: "Options",
                        },
                    ],
                    items: [],
                },
                fieldsMappingProduct: {
                    fields: [
                        {
                            key: "value",
                            label: "Value",
                        },
                        {
                            key: "name",
                            label: "Name",
                        },
                        {
                            key: "type",
                            label: "Type",
                            _active: false,
                        },
                        {
                            key: "fieldAdapter",
                            label: "Adapter Values",
                            _active: false,
                        },
                        {
                            key: "options",
                            label: "Options",
                        },
                    ],
                    items: [],
                },
            }),
            required: true,
        },
    },
    watch: {
        async value(newValue) {
            await this.assingValues(newValue);
        },
        "settings.fieldsMapping.items": {
            handler(newValue) {
                const updateValue = {
                    ...this.value,
                    fieldsMapping: newValue,
                };
                this.$emit("update:value", updateValue);
                this.$emit("change", updateValue);
            },
            deep: true,
        },
        "settings.fieldsMappingProduct.items": {
            handler(newValue) {
                const updateValue = {
                    ...this.value,
                    fieldsMappingProduct: newValue,
                };
                this.$emit("update:value", updateValue);
                this.$emit("change", updateValue);
            },
            deep: true,
        },
        "settings.fixedFields": {
            handler(newValue) {
                const updateValue = {
                    ...this.value,
                    fixedFields: newValue,
                };
                this.$emit("update:value", updateValue);
                this.$emit("change", updateValue);
            },
            deep: true,
        },
    },
    methods: {
        async assingValues(newValue) {
            if (newValue.fieldsMapping != undefined)
                this.settings.fieldsMapping.items = newValue.fieldsMapping;
            if (newValue.fieldsMappingProduct != undefined)
                this.settings.fieldsMappingProduct.items =
                    newValue.fieldsMappingProduct;
            if (newValue.fixedFields != undefined)
                this.settings.fixedFields = newValue.fixedFields;
        },
        async loadFieldsFromApiZoho() {
            let data = await this.fetcher({
                url: `/connector.api/integrations/${this.plugin_marketing_credentials_uuid}/actions/${this.$options.consts.ZOHO_ACTION_GET_FIELDS}/execute?module=${this.moduleApiName}`,
            });
            this.fieldsFromApiZoho = data["pluginActionResponse"]["names"];
            this.listValuesAdapterZoho =
                data["pluginActionResponse"]["options"];

            if (this.moduleApiName == "Sales_Orders") {
                let data = await this.fetcher({
                    url: `/connector.api/integrations/${this.plugin_marketing_credentials_uuid}/actions/${this.$options.consts.ZOHO_ACTION_GET_FIELDS}/execute?module=Products`,
                });
                this.fieldsProductFromApiZoho =
                    data["pluginActionResponse"]["names"];
                this.listValuesProductAdapterZoho =
                    data["pluginActionResponse"]["options"];
            }
        },
        async loadFields() {
            this.fieldsLG = [];
            this.listValuesAdapterLG = [];
            if (
                this.moduleApiName == "Leads" ||
                this.moduleApiName == "Contacts"
            ) {
                this.storeGlobalFieldsAdvance.map((item) => {
                    let options = null;
                    if (item.options) {
                        options = item.options.split(",\n");
                    }
                    this.fieldsLG.push(item.name);
                    this.listValuesAdapterLG[item.name] = options;
                });
            } else {
                let data = await this.fetcher({
                    url: `/connector.api/integrations/${this.plugin_marketing_credentials_uuid}/actions/${this.$options.consts.ZOHO_ACTION_GET_FIELDS_LG}/execute?module=${this.moduleApiName}`,
                });
                this.fieldsLG = data["pluginActionResponse"]["names"];
                this.listValuesAdapterLG =
                    data["pluginActionResponse"]["options"];

                if (this.moduleApiName == "Sales_Orders") {
                    this.fieldsProductLG = [];
                    this.listValuesProductAdapterLG = [];

                    let data = await this.fetcher({
                        url: `/connector.api/integrations/${this.plugin_marketing_credentials_uuid}/actions/${this.$options.consts.ZOHO_ACTION_GET_FIELDS_LG}/execute?module=Products`,
                    });
                    this.fieldsProductLG =
                        data["pluginActionResponse"]["names"];
                    this.listValuesProductAdapterLG =
                        data["pluginActionResponse"]["options"];
                }
            }
        },
        getDefaultTableItem(tableName) {
            let item = {};
            this.settings[tableName].fields.forEach((field) => {
                if (field.key != "options")
                    item = {
                        ...item,
                        [field.key]: null,
                    };
            });
            return item;
        },
        addItemToTable(tableName) {
            let defaultItem = this.getDefaultTableItem(tableName);
            let items = [...this.settings[tableName].items];
            items.push(defaultItem);
            this.$set(this.settings[tableName], "items", items);
        },
        deleteItemToTable(tableName, index) {
            this.settings[tableName].items.splice(index, 1);
        },
        validateSettings() {
            let valForm = this.$v.settings;
            if (!valForm) return false;
            valForm.$touch();
            return !valForm.$invalid;
        },
        checkIfSettingsValid({ fieldName }) {
            const field = this.$v.settings[fieldName];
            if (!field.$dirty) {
                return null;
            }
            return !(field.$invalid || field.$model === "");
        },
        async changeFieldMapping(index, mappingKey) {
            const field = await this.getTypeField(
                this.settings[mappingKey].items[index].name
            );

            if (field) {
                this.settings[mappingKey].items[index].type = field.type;
                return field.type;
            }

            return null;
        },
        async getTypeField(name) {
            return this.storeGlobalFieldsAdvance.find((field) => {
                return field.name == name;
            });
        },
        toggleDetails(tableName, index) {
            let item = this.settings[tableName].items[index];
            this.$set(
                this.settings[tableName].items[index],
                "_toggled",
                !item._toggled
            );
        },
        addItemToFieldAdapterTable(index, mappingKey) {
            let mappingItems = [...this.settings[mappingKey].items];

            if (!mappingItems[index].fieldAdapter) {
                mappingItems[index] = {
                    ...mappingItems[index],
                    fieldAdapter: [],
                };
            }

            if (!Array.isArray(mappingItems[index].fieldAdapter)) {
                mappingItems[index].fieldAdapter = [];
            }

            mappingItems[index].fieldAdapter.push({
                name: null,
                value: null,
            });

            this.settings[mappingKey].items = mappingItems;
        },

        deleteItemToFieldAdapterTable(index, adapterName, mappingKey) {
            const fieldAdapter =
                this.settings[mappingKey].items[index].fieldAdapter;

            if (!Array.isArray(fieldAdapter)) {
                return;
            }

            const findAdapter = fieldAdapter.findIndex(
                (adapter) => adapter.name == adapterName
            );

            if (findAdapter >= 0) {
                fieldAdapter.splice(findAdapter, 1);
            }
        },
        async getModuleName() {
            if (this.action_uuid) {
                this.moduleApiName = Object.keys(
                    this.$options.consts.ZOHO_ACTIONS_WEBHOOKS
                ).find(
                    (key) =>
                        this.$options.consts.ZOHO_ACTIONS_WEBHOOKS[key] ===
                        this.action_uuid
                );
            }
        },
    },
    async mounted() {
        await this.assingValues(this.value);
        await this.getModuleName();
        await this.loadFieldsFromApiZoho();
        await this.loadFields();
    },
    async created() {
        await this.loadFieldsAdvance();
    },
};
</script>

<style>
.overflow-visible .table-responsive {
    overflow: visible;
}
</style>
